export default "__VITE_ASSET__CEEDXSk___$_?url__"